module.exports = __webpack_public_path__ + "static/media/CC20-LC240-12.b8b6482b.png";